import { PermissionT } from "../types";

export const visionServiceBureauAdmin = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "vision_service_bureau_admin");
  return !!p;
};

export default visionServiceBureauAdmin;
